<div class="vehicle-wrapper">
    <div class="top-header">
        <h3>{{ pageTitle }}</h3>
        <p>{{ isEditMode ? 'Update monitoring details below. Vehicle number cannot be changed.' : 'Add a vehicle to the monitoring list' }}</p>
    </div>

    <div *ngIf="loading" class="loading-state">Loading vehicle monitoring rules...</div>

    <form *ngIf="!loading" [formGroup]="vehicleForm" (ngSubmit)="onSubmit()">
        <div class="form-row">
            <div class="form-item">
                <label for="vehicleNumber">Vehicle Number <small>*</small></label>
                <input type="text" formControlName="vehicleNumber" id="vehicleNumber" [readonly]="isEditMode">
                <div class="error"
                     *ngIf="vehicleForm.get('vehicleNumber')?.invalid && vehicleForm.get('vehicleNumber')?.touched">
                    <small *ngIf="vehicleForm.get('vehicleNumber')?.errors?.['required']">Vehicle Number is required.</small>
                </div>
            </div>
        </div>

        <div class="rules-section">
            <div class="rules-header">
                <h4>Monitoring Types</h4>
                <button type="button" class="btn-action btn-compact" (click)="addRuleRow()"
                        [disabled]="rules.length >= alertTypeOptions.length">
                    <fa-icon [icon]="['fas', 'plus']"></fa-icon>
                    Add Monitoring Type
                </button>
            </div>

            <div class="rule-card" *ngFor="let rule of rules.controls; let i = index" [formGroup]="$any(rule)">
                <div class="form-row">
                    <div class="form-item">
                        <label [for]="'alertType-' + i">Monitoring Type <small>*</small></label>
                        <select formControlName="alertType" [id]="'alertType-' + i">
                            <option value="" disabled>Select monitoring type</option>
                            <option *ngFor="let option of availableAlertTypes(i)" [value]="option.value">{{ option.label }}</option>
                            <option *ngIf="rule.get('alertType')?.value"
                                    [value]="rule.get('alertType')?.value">
                                {{ labelForAlertType(rule.get('alertType')?.value) }}
                            </option>
                        </select>
                    </div>
                    <div class="form-item">
                        <label [for]="'severity-' + i">Severity</label>
                        <select formControlName="severity" [id]="'severity-' + i">
                            <option *ngFor="let option of severityOptions" [value]="option.value">{{ option.label }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-item remarks-item">
                        <label [for]="'remarks-' + i">Remarks</label>
                        <textarea formControlName="remarks" [id]="'remarks-' + i" placeholder="Optional"></textarea>
                    </div>
                    <div class="rule-actions">
                        <button type="button" class="action-button bt-delete" (click)="removeRuleRow(i)"
                                [disabled]="rules.length === 1"
                                title="Remove monitoring type">
                            <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="button-row">
            <button type="submit" class="btn-save" [disabled]="saving">
                <fa-icon [icon]="['fas', isEditMode ? 'square-check' : 'square-plus']" class="fa-solid"></fa-icon>
                {{ saving ? 'Saving...' : submitLabel }}
            </button>
            <button type="button" class="btn-cancel" (click)="onCancel()" [disabled]="saving">
                <fa-icon [icon]="['fas', 'square-xmark']" class="fa-thin"></fa-icon> CANCEL
            </button>
        </div>
    </form>
</div>
